import { ReactComponent as CaleidoLogo } from 'assets/images/common/logo.svg';
import { ReactComponent as ButterflyIcon } from 'assets/images/common/logo-butterfly.svg';
import EmojiItem from '../EmojiItem';
import Button from 'components/v2/button/Button';
import OnboardingBgLogo from '../assets/onboarding-bg-logo.png';
import OnboardingBgLogoPurple from '../assets/onboarding-bg-logo-purple.png';
import MainImage from '../assets/main-image.jpg';
import CelebratingWithWine from '../assets/celebrating-with-wine.jpg';
import OutdoorVacation from '../assets/outdoor-vacation.jpg';

type Props = {
  onStartClick: () => void;
  onLoginClick: () => void;
};

const IntroOnboardingStep = ({ onStartClick, onLoginClick }: Props) => {
  return (
    <div className="relative w-full flex flex-col items-center justify-end h-screen">
      <div className="absolute top-[17svh] left-[6svh] z-10">
        <EmojiItem emoji="🍔" />
      </div>
      <div className="absolute top-[9svh] right-[6svh] z-10">
        <EmojiItem emoji="🥂" />
      </div>
      <div className="absolute top-[33svh] mx-auto z-10">
        <EmojiItem emoji="🍿" />
      </div>
      <div className="absolute top-[43svh] left-[6svh] z-10">
        <EmojiItem emoji="🏀" />
      </div>
      <div className="absolute top-[39svh] right-[6svh] z-10">
        <EmojiItem emoji="💃🏻" />
      </div>
      <div className="absolute top-[64svh] left-[4svh] z-10">
        <EmojiItem emoji="🎉" />
      </div>
      <div className="relative top-[38svh] mx-auto w-0 h-0 rounded-full opacity-60">
        <div className="absolute inset-0 shadow-[0px_0px_130px_130px_#3d20b3,0px_80px_200px_60px_#2b1c7a] bg-transparent rounded-full z-0"></div>
      </div>
      <div className="absolute top-[7svh] left-0">
        <img src={OnboardingBgLogo} alt="logo" />
      </div>
      <div className="absolute top-[41svh] right-0 opacity-50">
        <img src={OnboardingBgLogoPurple} alt="logo" className="w-full" />
      </div>
      <div className="absolute top-[15svh] right-[calc(50%-5.313rem)] flex items-center z-10 w-[6.5rem] h-[6.5rem] overflow-hidden rounded-full">
        <img src={CelebratingWithWine} alt="logo" />
      </div>
      <div className="absolute top-[-3.2svh] left-[calc(50%-6.313rem)] flex items-center z-10 w-[6.5rem] h-[6.5rem] overflow-hidden rounded-full">
        <img src={OutdoorVacation} alt="logo" />
      </div>
      <div className="flex w-full flex-col justify-end items-center gap-[2.5rem] h-full px-5 py-8">
        <div className="flex flex-col items-center justify-center gap-4">
          <div className="flex flex-col items-center gap-[3.125rem]">
            <div className="flex items-center z-10 w-[9.5rem] h-[9.5rem] overflow-hidden rounded-full">
              <img src={MainImage} alt="logo" className="mb-10" />
            </div>
            <div className="flex items-center">
              <CaleidoLogo className="h-[0.875rem]" />
            </div>
          </div>

          <div className="flex flex-col items-center justify-center text-[3.125rem]">
            <div className="text-semibold">See you</div>
            <div className="relative flex items-center gap-3">
              <div className="flex justify-center items-center relative text-normal text-[#6C6B76]">
                later{' '}
                <div className="absolute mr-1 mt-2 w-[7.2rem] bg-[#6C6B76] rotate-[-26deg] h-1 rounded-full"></div>
              </div>{' '}
              there
            </div>
          </div>
        </div>
        <div className="w-full flex flex-col items-center">
          <Button className="w-full py-4" onClick={onStartClick}>
            Start your journey
          </Button>
          <div
            className="text-white text-center mt-4 cursor-pointer"
            onClick={onLoginClick}
          >
            Log in
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntroOnboardingStep;
